import { Col, Row, Skeleton } from 'antd'
import React from 'react'
import { curriculumloaderProps } from './curriculumloader-interface'

const Curriculumloader = ({
	hasBottom = true
}: curriculumloaderProps) => {
	return (
		<div>
			<p className='text-base font-[900] text-appcolorpurplefaintone capitalize'>
				<Skeleton.Button
					active={true}
					size={'large'}
					shape={'square'}
					block={true}
					style={{
						height: '2rem',
						width: '6rem'
					}}
				/>
			</p>

			<div className='pt-4 mt-4 border-t-[0.3px] border-appcolorpurplefaintone flex w-full'>
				<Row gutter={8} className="w-full">
					<Col xs={24} md={24} lg={12}>
						<Skeleton.Button
							active={true}
							size={'large'}
							shape={'square'}
							block={true}
							style={{
								height: '2rem',
								width: '13rem',
								marginBottom: '1rem'
							}}
						/>
					</Col>

					<Col xs={24} md={24} lg={12}>
						<Skeleton.Button
							active={true}
							size={'large'}
							shape={'square'}
							block={true}
							style={{
								height: '2rem',
								width: '13rem',
								marginBottom: '1rem'
							}}
						/>
					</Col>

					<Col xs={24} md={24} lg={12}>
						<Skeleton.Button
							active={true}
							size={'large'}
							shape={'square'}
							block={true}
							style={{
								height: '2rem',
								width: '13rem',
								marginBottom: '1rem'
							}}
						/>
					</Col>

					<Col xs={24} md={24} lg={12}>
						<Skeleton.Button
							active={true}
							size={'large'}
							shape={'square'}
							block={true}
							style={{
								height: '2rem',
								width: '13rem',
								marginBottom: '1rem'
							}}
						/>
					</Col>

					{
						hasBottom ?
							<>
								<Col xs={24} md={24} lg={12}>
									<Skeleton.Button
										active={true}
										size={'large'}
										shape={'square'}
										block={true}
										style={{
											height: '4rem',
											width: '20rem',
											marginBottom: '1rem'
										}}
									/>
								</Col>

								<Col xs={24} md={24} lg={12}>
									<Skeleton.Button
										active={true}
										size={'large'}
										shape={'square'}
										block={true}
										style={{
											height: '4rem',
											width: '20rem',
											marginBottom: '1rem'
										}}
									/>
								</Col>
							</>
							:
							null
					}
				</Row>
			</div>
		</div>
	)
}

export default Curriculumloader